import React, { useState } from 'react'
import { Button } from '../../../components/common'
import CopyIcon from '../../../components/common/icons/CopyIcon'
import { useYoutubeVideos } from '../api'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../../store/authStore'

const YouTubeVideos: React.FC = () => {
  const { language } = useAuthStore()
  const [copiedId, setCopiedId] = useState<string | null>(null)
  const { data, isLoading } = useYoutubeVideos()
  const navigate = useNavigate()
  if (isLoading) {
    return <div className="text-center py-8">Loading videos...</div>
  }

  if (!data) {
    return <div className="text-center py-8">No videos found.</div>
  }
  const videosToShow = data?.data?.slice(0, 2) || []
  const handleCopy = async (url: string, id: string) => {
    try {
      await navigator.clipboard.writeText(url) // copies link
      setCopiedId(id)
      setTimeout(() => setCopiedId(null), 2000) // reset after 2s
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  return (
    <div className="bg-[#fffff]">
      <div className="py-10 lg:px-4 w-11/12 mx-auto">
        <h2 className="text-lg font-semibold mb-6">
          {language === 'lang_mal' ? 'യൂട്യൂബ് വീഡിയോകൾ' : 'YouTube Videos'}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {videosToShow.map((video: any) => (
            <div key={video.id} className="bg-white shadow rounded-md">
              <div className="lg:w-full lg:h-[350px] xs:h-[250px]">
                <iframe
                  className="w-full h-full"
                  src={
                    video.type === 'url'
                      ? video.source
                          .replace('youtube.com/', 'youtube.com/embed/')
                          .replace('youtu.be/', 'youtube.com/embed/')
                      : video.source
                  }
                  title={video?.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="flex justify-between p-2">
                <div className="text-sm text-gray-700 mt-2">{video.title}</div>
                {/* <button
                  className="text-xs text-primaryBlue mt-1 hover:underline flex gap-2 items-center"
                  onClick={() => navigator.clipboard.writeText(video.source)}
                >
                  Copy Link{' '}
                  <span>
                    <CopyIcon />
                  </span>
                </button> */}
                <button
                  onClick={() => handleCopy(video.source, video.id)}
                  className="text-xs text-primaryBlue mt-1 hover:underline flex gap-2 items-center"
                >
                  {copiedId === video.id ? 'Copied!' : 'Copy Link'}
                  <span>
                    <CopyIcon />
                  </span>
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-6">
          <div className="flex justify-center mt-4">
            <Button
              label={language === 'lang_mal' ? 'കൂടുതൽ കാണുക' : 'View More'}
              className="lg:px-16 lg:min-h-12"
              onClick={() => {
                navigate('/video_gallery')
                window.scrollTo({ top: 0, behavior: 'smooth' })
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default YouTubeVideos
